import styled from 'styled-components';

export const Root = styled.div`
  width: calc(50% - 32px - 56px);
  margin: 40px 60px 0px 60px;
`

export const Title = styled.span`
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
`